import { type ChangeEvent } from 'react';

import { FormField, InputField } from '@ssnc/bsds-core';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function SearchInput({ value, onChange }: SearchInputProps) {
  return (
    <FormField label="Search organizations" hideLabel htmlFor="tenant-search">
      <InputField
        id="tenant-search"
        name="tenant-search"
        type="search"
        placeholder="Search by organization name…"
        value={value}
        onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
        autoFocus
      />
    </FormField>
  );
}
